import React from 'react';
import { AbsoluteFill } from 'remotion';
import { SMART_GUIDE_COLOR, SMART_GUIDE_LINE_WIDTH } from './constants';
import { useSmartGuidesOptional } from './smart-guide-context';

export const SmartGuideLines: React.FC = () => {
  const smartGuides = useSmartGuidesOptional();

  if (!smartGuides || smartGuides.activeGuides.length === 0) {
    return null;
  }

  return (
    <AbsoluteFill style={{ pointerEvents: 'none' }}>
      {smartGuides.activeGuides.map((guide, index) => {
        if (
          guide.type === 'vertical-center' ||
          guide.type === 'left-edge' ||
          guide.type === 'right-edge' ||
          guide.type === 'vertical-item'
        ) {
          return (
            <div
              key={`${guide.type}-${index}`}
              style={{
                position: 'absolute',
                left: guide.position,
                top: 0,
                bottom: 0,
                width: SMART_GUIDE_LINE_WIDTH,
                backgroundColor: SMART_GUIDE_COLOR,
                transform: 'translateX(-50%)',
                zIndex: 9999,
              }}
            />
          );
        }

        if (
          guide.type === 'horizontal-center' ||
          guide.type === 'top-edge' ||
          guide.type === 'bottom-edge' ||
          guide.type === 'horizontal-item'
        ) {
          return (
            <div
              key={`${guide.type}-${index}`}
              style={{
                position: 'absolute',
                top: guide.position,
                left: 0,
                right: 0,
                height: SMART_GUIDE_LINE_WIDTH,
                backgroundColor: SMART_GUIDE_COLOR,
                transform: 'translateY(-50%)',
                zIndex: 9999,
              }}
            />
          );
        }

        return null;
      })}
    </AbsoluteFill>
  );
};
